module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-43.7e12c5fb.png";